export enum FaqType {
  HOST_COMMON = 'HOST_COMMON',
  HOST_MAKE_FRIP = 'HOST_MAKE_FRIP',
  HOST_BEFORE_OPEN = 'HOST_BEFORE_OPEN',
  HOST_AFTER_OPEN = 'HOST_AFTER_OPEN',
  HOST_BILL = 'HOST_BILL',
  HOST_ETC = 'HOST_ETC',
}

export const FaqTypeLabel: { value: FaqType; label: string; type: string }[] = [
  {
    value: FaqType.HOST_COMMON,
    label: '일반',
    type: 'secondary',
  },
  {
    value: FaqType.HOST_MAKE_FRIP,
    label: '등록',
    type: 'primary',
  },
  {
    value: FaqType.HOST_BEFORE_OPEN,
    label: '오픈전',
    type: 'info',
  },
  {
    value: FaqType.HOST_AFTER_OPEN,
    label: '오픈후',
    type: 'warning',
  },
  {
    value: FaqType.HOST_BILL,
    label: '정산',
    type: 'danger',
  },
  {
    value: FaqType.HOST_ETC,
    label: '기타',
    type: 'success',
  },
];
